import { Component, inject } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';
import { TransportSectionComponent } from '../transport-section/transport-section.component';

import { PrestationEmptyStateComponent } from '../prestation-empty-state/prestation-empty-state.component';
import { PrestationModalComponent } from '../../prestation-modal/prestation-modal.component';
import { AccommodationSectionComponent } from '../accommodation-section/accommodation-section.component';
import { ActivitySectionComponent } from '../activity-section/activity-section.component';
import { PrestationModalService } from 'src/app/trip-calculator/services/prestation-modal.service';
import { TripService } from 'src/app/trip-calculator/services/trip.service';

@Component({
  selector: 'app-prestation-section',
  imports: [
    TranslocoPipe,
    TransportSectionComponent,
    PrestationEmptyStateComponent,
    PrestationModalComponent,
    AccommodationSectionComponent,
    ActivitySectionComponent,
  ],
  templateUrl: './prestation-section.component.html',
})
export class PrestationSectionComponent {
  tripService = inject(TripService);
  prestationModalService = inject(PrestationModalService);
  openPrestationModal = () => {
    this.prestationModalService.selectPrestation();
  };
}
